//Constants for the product types
export const productTypes = {
  neumatico: 1,
  llanta: 2,
  servicio: 3,
};
